var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preserve-icon"},_vm._l((_vm.imgList),function(item){return _c('img',{class:'icon'+item,attrs:{"data-src":_vm.g+'/'+item+'.png'}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }